var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-fullVw h-fullVh"},[_c('iframe',{ref:"faceFrame",staticClass:"faceFrame",attrs:{"id":"faceFrame","width":"100%","height":"100%","src":_vm.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }